import { useEffect } from "react";

export const usePageMeta = (title, path) => {
  useEffect(() => {
    const url = `https://ecu-solutions.de${path}`;
    document.title = title;
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
    document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", title);
    document.querySelector('meta[name="twitter:title"]')?.setAttribute("content", title);
  }, [title, path]);
};
